import intersectionWith from 'hs-lodash/intersectionWith';
import { useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { List } from 'foundations-components/transitional/components/List';
import { convertToLegacyLanguage } from 'academy-common-lib/constants/academySupportedLanguages';
import FinishedContainer from '../../../components/FinishedContainer';
import { usePlaylistIdFromSearch } from '../hooks';
import { usePlaylistRemainingItemsAndProgress } from '../../savedItems/savedItemsHooks';
import { useFullPlaylist } from '../../savedItems/savedItemsQueries';
import { RouterLink } from '../../../components/AcademyLinks';
import { getListingUrl } from 'academy-common-lib/features/learningContentCard/routing/RoutingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentLink = ({
  playlistItem: {
    itemId,
    language,
    type,
    name
  }
}) => {
  const playlistId = usePlaylistIdFromSearch();
  return /*#__PURE__*/_jsx(RouterLink, {
    to: getListingUrl({
      type: type,
      id: itemId,
      isStarted: true,
      language: convertToLegacyLanguage(language),
      playlistId,
      appearsIn: 'playlist'
    }),
    children: name
  }, `${itemId}${type.toString()}${name}`);
};
export const PlaylistIncompleteItems = ({
  navMarkerName
}) => {
  const playlistId = usePlaylistIdFromSearch();
  const {
    remainingProgressItems
  } = usePlaylistRemainingItemsAndProgress(playlistId);
  const {
    playlist,
    displayedPlaylistItems
  } = useFullPlaylist(playlistId);
  const incompleteItems = useMemo(() => {
    if (!remainingProgressItems || !displayedPlaylistItems) return [];
    return intersectionWith(displayedPlaylistItems, remainingProgressItems, (playlistItem, item) => {
      return item.itemId === playlistItem.itemId && item.type === playlistItem.type;
    });
  }, [displayedPlaylistItems, remainingProgressItems]);
  const body = playlist && /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H3, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistContent.incompletePlaylistContent.incompleteTitle",
        options: {
          playlistTitle: playlist.name
        }
      })
    }), incompleteItems.length > 0 && /*#__PURE__*/_jsx(List, {
      wrapChildren: true,
      children: incompleteItems.map(item => /*#__PURE__*/_jsx(ContentLink, {
        playlistItem: item
      }, `${item.itemId}${item.type.toString()}${item.name}`))
    })]
  });
  if (navMarkerName) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName,
      children: /*#__PURE__*/_jsx(FinishedContainer, {
        body: body,
        illustration: /*#__PURE__*/_jsx(Illustration, {
          name: "announcement"
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(FinishedContainer, {
    body: body,
    illustration: /*#__PURE__*/_jsx(Illustration, {
      name: "announcement"
    })
  });
};